import gql from 'graphql-tag'
import toGraphql from '@iez/lib/to-graphql/'

const mutationName = root => `update_${root}_by_pk`

export default ({ root, fields }) => gql`
  mutation (
    $id: uuid!
    $_set: ${root}_set_input
  ) {
    ${mutationName(root)} (
      pk_columns: {
        id: $id
      }
      _set: $_set
    ) {
      ${toGraphql(fields)}
    }
  }
`
